import CookieConsent from "react-cookie-consent";

const CookieComp = () => {
    return (
        <>
            <CookieConsent
                style={{
                    background: '#10D8EF',
                    textAlign: 'center',
                    color: '#000000',
                    fontWeight: 400,
                }}
                buttonStyle={{
                    background: '#fdb808',
                    fontSize: '18px',
                    fontWeight: 500,
                }}
                cookieName="UeComixCookieAccept"
                expires={365}
            >
                This website uses cookies to ensure you get the best experience on our website. <a href="/cookie-policy"><b><u>Learn more about Cookies</u></b></a>, <a href="/terms"><b><u>Terms & Conditions</u></b></a>, <a href="/privacy-policy"><b><u>Privacy Policy</u></b></a> 
            </CookieConsent>
        </>
    )
}

export default CookieComp;